export default __webpack_public_path__ + "static/media/2394.5f35712d.png";